package com.essntl.features.task.ui.addedittask.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.features.task.ui.addedittask.AddEditTaskEvent
import com.essntl.features.task.ui.addedittask.AddEditTaskState
import com.essntl.features.task.ui.addedittask.AddEditTaskValidation
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.input.date.EsDateInput
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import core.dateformat.ui.formatDate

@Composable
fun TaskForm(
    state: AddEditTaskState,
    onEvent: (AddEditTaskEvent) -> Unit,
    validation: AddEditTaskValidation,
    enabled: Boolean,
    getAllTask: List<TaskModel>?,
    modifier: Modifier = Modifier,
) {
    val task = state.task.value

    Column(
        modifier = modifier
            .background(
                color = MaterialTheme.esColorScheme.bgSecondary,
                shape = RoundedCornerShape(EsConstants.RoundedCornerSize),
            )
            .padding(
                vertical = 3.spacing,
                horizontal = 2.5f.spacing,
            )
            .verticalScroll(rememberScrollState()),
    ) {
        EsInput(
            value = task.title ?: "",
            onValueChange = {
                validation.addEditTaskForm.title.validate(it)
                onEvent(
                    AddEditTaskEvent.UpdateTaskFields(
                        task.copy(
                            title = it,
                        ),
                    ),
                )
            },
            placeholder = "Enter Title",
            state = validation.addEditTaskForm.title.state,
            message = validation.addEditTaskForm.title.errorMessage ?: "This field is required",
            label = "Title",
            enabled = enabled && !state.addEditTask.isLoading,
        )

        Spacer(modifier = Modifier.height(2.spacing))

        EsInput(
            value = task.notes ?: "",
            onValueChange = {
                onEvent(
                    AddEditTaskEvent.UpdateTaskFields(
                        task.copy(
                            notes = it,
                        ),
                    ),
                )
            },
            placeholder = "Enter Notes",
            label = "Notes",
            enabled = enabled && !state.addEditTask.isLoading,
            singleLine = false,
            minLines = 2,
        )

        Spacer(modifier = Modifier.height(2.spacing))

        EsDateInput(
            value = task.dueDate.orEmpty(),
            onValueChange = {
                validation.addEditTaskForm.dueDate.validate(it)
                onEvent(
                    AddEditTaskEvent.UpdateTaskFields(
                        task.copy(
                            dueDate = (it),
                        ),
                    ),
                )
            },
            label = "Due date",
            state = validation.addEditTaskForm.dueDate.state,
            message = validation.addEditTaskForm.dueDate.errorMessage ?: "This field is required",
            enabled = enabled && !state.addEditTask.isLoading,
        )

        state.getProfile.data?.let {
            Spacer(modifier = Modifier.height(2.spacing))
            Row(
                horizontalArrangement = Arrangement.spacedBy(3.spacing),
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.fillMaxWidth(),
            ) {
                task.updatedAt?.let { updatedAt ->
                    Row(
                        horizontalArrangement = Arrangement.Center,
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        val formattedUpdatedAt = updatedAt.formatDate(".")

                        Text(
                            text = "Last modified: ",
                            style = MaterialTheme.esTypography.c1Medium13,
                            color = MaterialTheme.esColorScheme.textDisabled,
                        )

                        val updateAtString =
                            remember {
                                if (updatedAt.length >= 10)
                                    formattedUpdatedAt else
                                    ""
                            }

                        Text(
                            text = updateAtString,
                            style = MaterialTheme.esTypography.c1Medium13,
                            color = MaterialTheme.esColorScheme.textTertiary,
                        )
                    }
                }

                Row(
                    horizontalArrangement = Arrangement.Center,
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    Text(
                        text = "By: ",
                        style = MaterialTheme.esTypography.c1Medium13,
                        color = MaterialTheme.esColorScheme.textDisabled,
                    )
                    Text(
                        text = (it.firstName ?: "") + " " + (it.lastName ?: ""),
                        style = MaterialTheme.esTypography.c1Medium13,
                        color = MaterialTheme.esColorScheme.textTertiary,
                    )
                }
            }
        }

        Spacer(modifier = Modifier.height(2.spacing))

        TaskOwnerSection(
            state = state,
            validation = validation,
            onEvent = onEvent,
            enabled = enabled,
        )

        if (getAllTask != null &&
            task.id.isNotEmpty() &&
            task.itineraryService != null
        ) {
            Spacer(modifier = Modifier.height(2.spacing))
            TaskServiceSection(
                state = state,
            )
        }
    }
}
